import { defineComponent as _defineComponent } from 'vue'
import { computed, useContext, useRoute } from '@nuxtjs/composition-api';
import TLinkButton from '~/components/atoms/t-link-button.vue';
import { useLocale } from '~/composables/useLocale';

interface HeroProps {
  title: string;
  image: string;
  cta: {
    title: string;
    url: string;
  };
}

interface Props {
  content: HeroProps;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SectionHero',
  props: {
    content: null
  },
  setup(__props: any) {

const openUsBtsLink = () => {
  globalThis.location.assign(
    'https://www.teachstarter.com/us/teaching-resource-collection/first-day-of-school-activities/'
  );
};

const { $isFlagOn, store } = useContext();
const route = useRoute();
const locale = useLocale();

const isLoggedOut = computed(() => !store.getters.isAuthenticated);
const isHomepage = computed(() => route.value?.name?.toString().startsWith('index') ?? false);

const showUsBtsBanner = computed(() => {
  const now = new Date();
  const startoff = new Date('2026-07-13T00:00:00Z');
  const cutoff = new Date('2026-09-27T00:00:00Z');
  return (
    $isFlagOn('bts-us-2026') &&
    locale.value === 'us' &&
    isLoggedOut.value &&
    isHomepage.value &&
    now >= startoff &&
    now < cutoff
  );
});



return { __sfc: true,openUsBtsLink, $isFlagOn, store, route, locale, isLoggedOut, isHomepage, showUsBtsBanner, TLinkButton }
}

})